import React from 'react';
import { Col, Row } from 'antd';
import { Link } from 'react-router-dom';
// import moment from 'moment';
import 'moment/locale/es';
import { ECE, ASSISTANT, TEACHER } from '@BUP/constants';
import { useAuth } from '@BUP/hooks';
import DefaultResourceImage from '@BUP/assets/Images/Resources/default_resource.png';
import styles from './resource-element.module.css';

const ResourceBupCard = ({ topic, resource, resourceId }) => {
  const descriptionTopic = topic?.topic?.description || '';
  const descriptionResource = resource?.description;
  const { user } = useAuth();
  const roleType = user?.roles.type;
  return (
    <>
      {roleType === ECE || roleType === ASSISTANT || roleType === TEACHER ? (
        <Link to={`resources/${resource?.id}`}>
          <Col className={styles.card_wrapper}>
            <Row>
              <Col
                className={styles.image_wrapper}
                style={{
                  backgroundImage: `url(${
                    resource.imgUrl || DefaultResourceImage
                  })`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                }}
              />
              <Col className={styles.text_wrapper}>
                {/* <div>
                  <h5 className={styles.date_text}>
                    {moment(resource?.createdAt).format('ll')}
                  </h5>
                </div> */}
                <div className={styles.name_wrapper}>
                  <h4 className={styles.title}>{resource?.name}</h4>
                </div>
                <div>
                  <h5 className={styles.text}>
                    {descriptionResource
                      ? `${descriptionResource.slice(0, 125)}...`
                      : null}
                  </h5>
                </div>
              </Col>
            </Row>
          </Col>
        </Link>
      ) : (
        <Link
          to={`resources/${resourceId}/level/${topic?.levelId}/topic/${topic?.topic?.id}`}
        >
          <Col className={styles.card_wrapper}>
            <Row>
              <Col
                className={styles.image_wrapper}
                style={{
                  backgroundImage: `url(${
                    topic?.topic?.imgUrl || DefaultResourceImage
                  })`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                }}
              />
              <Col className={styles.text_wrapper}>
                {/* <div>
                  <h5 className={styles.date_text}>
                    {moment(topic?.topic?.createdAt).format('ll')}
                  </h5>
                </div> */}
                <div className={styles.name_wrapper}>
                  <h4 className={styles.title}>{topic?.topic?.name}</h4>
                </div>
                <div>
                  <h5 className={styles.text}>
                    {descriptionTopic.slice(0, 125)}...
                  </h5>
                </div>
              </Col>
            </Row>
          </Col>
        </Link>
      )}
    </>
  );
};

export default ResourceBupCard;
